import { Tap, defineTapPropertyExtension } from '@iotize/tap';

import { TapConfigProvider } from './tap-config-provider';

declare module '@iotize/tap/lib/tap' {
  interface Tap {
    config: TapConfigProvider;
  }
}

export const _TAP_EXTENSION_CONFIG_ = defineTapPropertyExtension(
  'config',
  (context) => {
    return new TapConfigProvider();
  },
);
